module.exports = __webpack_public_path__ + "static/media/st.6d680012.png";